import { ExchangeFormEventNames } from '@kanoAssets/js/exchange-form/types';

import { RatesBlockCryptoCarousel } from './rates-crypto-currency-list';
import { HowToBlockSlider } from '../blocks/how-to-blocks-slider';
import { GlobalStorage } from './global-storage';
import eventBus from '../helpers/event-bus';
import { updateContent } from '../blocks/seo-content-blocks';

document.addEventListener('DOMContentLoaded', () => {
  GlobalStorage.init();
  RatesBlockCryptoCarousel.init();
  HowToBlockSlider.init();
});

eventBus.on(ExchangeFormEventNames.FORM_DATA_UPDATED, (params) => {
  const {
    relationLink,
    currencyCodeFrom,
    currencyCodeTo,
    isServiceFromCrypto,
  } = params;
  const fiatCurrencyCode = isServiceFromCrypto ? currencyCodeTo : currencyCodeFrom;

  updateContent(relationLink, fiatCurrencyCode);
});
